const isIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    // iPadOS 13+ reports as Mac
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const isAndroid = () => /Android/.test(navigator.userAgent);

/**
 * Builds a maps URL for the given address, choosing the scheme per platform so
 * each OS opens its own default navigation app:
 * - iOS / macOS → Apple Maps (safe web fallback on desktop)
 * - Android → `geo:` scheme, routed to the user's default nav app
 * - Desktop / other → Google Maps web search
 */
export const getMapsSearchUrl = (address: string): string => {
    const q = encodeURIComponent(address);
    if (isIOS()) return `https://maps.apple.com/?q=${q}`;
    if (isAndroid()) return `geo:0,0?q=${q}`;
    return `https://www.google.com/maps/search/?api=1&query=${q}`;
};
